import { createApp } from 'vue';
import Configurator from './components/Configurator.vue';

document.addEventListener('DOMContentLoaded', () => {
    console.log('RoTech Configurator Plugin loaded');

    const element = document.getElementById('rotech-configurator-plugin');

    if (element) {
        const productId = element.getAttribute('data-product-id');

        // App initialisieren mit dem ausgelesenen 'data-product-id'
        createApp(Configurator, { productId }).mount('#rotech-configurator-plugin');
    } else {
        console.error('Element mit ID "rotech-configurator-plugin" nicht gefunden.');
    }
});